<template>
  <div v-if="hasFetchedData">
    <vs-button class="mb-4" v-if="!hasFetchedData" @click="fetchData"
      >Fetch data</vs-button
    >
    <h3 class="mb-1">Filters</h3>
    <vs-card class="pb-4 mb-10">
      <vs-row>
        <vs-select
          label="Country"
          multiple
          v-model="filters.country"
          class="mr-3"
        >
          <vs-select-item
            :key="index"
            :value="item"
            :text="item"
            v-for="(item, index) in countries"
          />
        </vs-select>
        <vs-select
          label="Region"
          multiple
          v-model="filters.region"
          class="mr-3"
        >
          <vs-select-item
            :key="index"
            :value="item"
            :text="getRegionName(item)"
            v-for="(item, index) in regions"
          />
        </vs-select>
        <vs-select label="Venue" multiple v-model="filters.venue" class="mr-3">
          <vs-select-item
            :key="index"
            :value="item.name"
            :text="item.name"
            v-for="(item, index) in filteredVenues"
          />
        </vs-select>
      </vs-row>
    </vs-card>

    <div v-for="(venue, idx) in filteredVenues" :key="idx">
      <vs-row style="margin-bottom: -3.5em">
        <div>
          <vs-row>
            <h3>{{ venue.name }}</h3>
            <!--<a class="ml-2" @click="toggleVisibility(venue.venueId)">
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </a>-->
          </vs-row>
          <br />
          <p>
            {{ venue.users.length }} employees.
            {{ venue.users.filter((e) => e.numCompleted > 0).length }} with at
            least one badge.
            {{ venue.users.filter((e) => e.numCompleted === 10).length }} with
            all badges. Users are sorted by number of badges.
          </p>
        </div></vs-row
      >
      <vs-row>
        <vs-table
          max-items="20"
          pagination
          search
          :data="venue.users"
          style="width: 100%"
        >
          <template slot="thead">
            <vs-th>Image</vs-th>
            <vs-th>Name</vs-th>
            <vs-th>Campus level</vs-th>
            <vs-th>Number of badges</vs-th>
            <vs-th>Badges</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="item.userId" v-for="item in data">
              <vs-td>
                <img
                  class="rounded-full profile-image"
                  :src="profilePicture(item.userId)"
                  onerror="this.src='https://i.imgur.com/pH8JUMc.png'"
                />
              </vs-td>
              <vs-td :data="item.displayName">
                {{ item.displayName }}
              </vs-td>
              <vs-td :data="item.numCompleted">
                Level {{ item.positionLevel }} ({{
                  item.positionLevelSince | formatDate
                }})
              </vs-td>
              <vs-td :data="item.numCompleted">
                {{ item.numCompleted }} Badges
              </vs-td>
              <vs-td>
                <badge-row :badges="item.badges" />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import moment from "moment";

import BadgeRow from "./BadgeRow.vue";

export default {
  components: { BadgeRow },
  data() {
    return {
      hasFetchedData: false,
      moment,
      combinedData: null,
      allRegions: null,
      venueVisibility: {},
      filters: {
        country: [],
        region: [],
        venue: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      userId: "users/userId",
      venues: "payrates/userVenuesDetails",
      //venues: "venues/venues",
      regions: "regions",
    }),
    countries() {
      return _.uniq(this.filteredVenues.map((e) => e.country)).filter(
        (e) => e !== ""
      );
    },
    regions() {
      return _.uniq(this.filteredVenues.map((e) => e.regionId)).filter(
        (e) => e !== ""
      );
    },
    filteredVenues() {
      console.log("Venues", this.venues);
      return this.venues
        .map((e) => {
          return { visible: true, ...e };
        })
        .filter(
          (e) =>
            this.InOrNoFilter(this.filters.country, e.country) &&
            this.InOrNoFilter(this.filters.region, e.regionId) &&
            this.InOrNoFilter(this.filters.venue, e.name)
        );
    },
  },

  methods: {
    /*showVenue(id) {
      return !this.venueVisibility[id];
    },
    toggleVisibility(id) {
      console.log("Runing before", this.showVenue(id));
      if (this.venueVisibility[id]) {
        this.venueVisibility[id] = false;
      } else {
        this.venueVisibility[id] = true;
      }
    },*/
    profilePicture(userId) {
      return `https://rekomlifestorageprod.blob.core.windows.net/user-uploads/avatars/${userId}.jpg`;
    },
    InOrNoFilter(list, item) {
      return item !== null && (list.length < 1 || list.includes(item));
    },
    getRegionName(id) {
      const reg = _.find(this.allRegions, (e) => e.id === id);
      return reg ? reg.name : "No name";
    },
    getRegions: function () {
      this.$http
        .get(process.env.VUE_APP_API_BASE_URL + "/Idam/Region")
        .then((resp) => {
          this.allRegions = resp.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {});
    },
    async fetchData() {
      await this.getRegions();
      await this.$store.dispatch("payrates/getUserVenuesDetails");
      this.hasFetchedData = true;
    },
  },
  async mounted() {
    this.$vs.loading({
      text: "Loading data. This can take up to a minute.",
    });
    await this.fetchData();
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
.profile-image {
  object-fit: cover;
  width: 50px;
  height: 50px;
}

#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}

#profile-tabs > div.con-ul-tabs > ul > li:nth-child(4) {
  list-style-position: inside;
  border-bottom: 1px solid #b3b3b3;
  margin-right: 10px;
}
</style>